import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Container, Col, Row, Button, Tab, Tabs, Table, Accordion } from "react-bootstrap";
import Slider from 'react-slick';
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "../../utils/useLocalStorage";
import Pagination from "../../CommonUI/Pagination/Pagination";
import { Portal } from "@material-ui/core";
import { Modal } from "react-bootstrap";
import { Vortex } from 'react-loader-spinner';
import './IPOCard.css';

function IPOCard() {
    const [show, setShow] = useState(false);
    const { BaseURL } = useContext(URLstateContext);
    const [dataWatch, setDataWatch] = useState([]);

    const [data, setData] = useState(false);
    const { BaseLiveURL } = useContext(URLstateContext);
    const [nodatafound, setnodatafound] = useState(false);

    const [loadingshow, setloadingshow] = useState(false);
    let getDataWatch, getDataaa, getDataList, getDataPer;
    let navigate = useNavigate();
    let PageSize = 5;

    // useEffect(() => {
    //     setloadingshow(true);
    //     const getUrlWatch = BaseURL + "Forthcoming";
    //     fetch(`${getUrlWatch}/1/8/-/-/-/-`)
    //         .then((response) => response.json())
    //         .then((dataW) => {
    //             getDataWatch = dataW.data;
    //             setDataWatch(getDataWatch);

    //             setloadingshow(false);
    //             //console.log(getDataWatch, "getDataWatch")
    //         })
    //         .catch((error) => {
    //         });
    // }, []);


    useEffect(() => {
        postData('/api/Login/MarketBanner', { Caption: "IPO" })
            .then((data) => {

                if (data.data != null && data.data.length > 0) { setnodatafound(false); setData(data.data); }
                else { setData(null); setnodatafound(true); }
            });
    }, []);

    async function postData(url = '', data = {}) {

        const response = await fetch(url, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json'
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(data) // body data type must match "Content-Type" header
        });
        return response.json(); // parses JSON response into native JavaScript objects
    }

    const images = data &&
        data.map(image => {
            return (
                <a href={image.bannerUrl} target="_blank">
                    <img key={image.uploadfile} src={BaseLiveURL + "marketimages/" + image.uploadfile} className="img-responsiveIpo moreContent" />
                </a>
            )
        });

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                    autoplay: true,
                    autoplaySpeed: 2000,
                }
            },
            {
                breakpoint: 767,

                settings: {
                    slidesToShow: 1,
                    infinite: true,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    autoplay: true,
                    autoplaySpeed: 2000,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    initialSlide: 1,
                    autoplay: true,
                    autoplaySpeed: 2000,
                },
            },
            {
                breakpoint: 360,
                settings: {
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    initialSlide: 1,
                },
            },
        ],
    };

    return (
        <div className='market-right-scIpo IPOCard'>
            <Slider className='market-slider' {...settings}>
                {images}
            </Slider>
            {nodatafound &&
                <p className="textcenter nodata">No Image found !!!</p>
            }
            {/* <div className='ipo-right-pnl'>
                <h2>Latest IPO</h2>
                {(dataWatch === null) ? <div className="errorMsg"><h3>No Data Found !!!</h3></div> : ''}
                {(dataWatch != undefined) ?
                    <>
                        <label>Company Name :</label>
                        <p>{(dataWatch[0] != undefined) ? (dataWatch[0].LNAME) : ''}</p>
                        <label>Issue Type :</label>
                        <p>{(dataWatch[0] != undefined) ? (dataWatch[0].IssueType) : ''}</p>
                        <label>Issue Size(&#8377; Cr.) :</label>
                        <p>{(dataWatch[0] != undefined) ? (dataWatch[0].IssueSize) : ''}</p>
                        <label>Offer Price(&#8377;Cr.) :</label>
                        <p>{(dataWatch[0] != undefined) ? (dataWatch[0].ISSUEPRICE) : ''}</p>
                    </>
                    : ''}
                <div className='market-btn'>
                    <a href="https://ekyc.moneysukh.com:8443/index.aspx" target="_blank">Get Started</a>
                </div>
                {loadingshow ? <div className="textcentervertex">
                    <Vortex
                        visible={true}
                        height="80"
                        width="80"
                        ariaLabel="vortex-loading"
                        wrapperStyle={{}}
                        wrapperClass="vortex-wrapper"
                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                    />
                    <div className="model_popup">Please Wait...</div>
                </div> : ""
                }

            </div> */}
        </div>
    )
}

export default IPOCard